import React, {Component} from 'react';
import couterpart from 'counterpart';

import WorkOrderImagesPrint from './WorkOrderImagesPrint';
import WorkOrderUtil from '../utilities/WorkOrderUtil';

import '../css/style.css';

class WorkOrderPrint extends Component {
     
    render() {
        const work_order_work_card_no = couterpart.translate('work_order_work_card_no');
        const work_order_order_date_s = couterpart.translate('work_order_order_date_s');
        const work_order_start_date = couterpart.translate('work_order_start_date');
        const work_order_end_date = couterpart.translate('work_order_end_date');
        const work_order_code = couterpart.translate('work_order_code');
        const work_order_code_p = couterpart.translate('shop_pcode');
        const work_order_color = couterpart.translate('work_order_color');
        const work_order_type = couterpart.translate('work_order_type');
        const work_order_quantity_s = couterpart.translate('work_order_quantity_s');
        const work_order_size = couterpart.translate('work_order_size');
        const work_order_customer_s = couterpart.translate('work_order_customer_s');
        const work_order_urgent = couterpart.translate('work_order_urgent');
        const work_order_customer_note = couterpart.translate('work_order_customer_note');
        const work_order_special_note = couterpart.translate('work_order_special_note');

        if (this.props.workOrder.workOrderNo !== undefined){
            return (
                <div className="woContainer">
                    <div className="woContainerBarcode">
                        <div className="woCell qrCode">
                            <img alt="" src={"data:image/gif;base64," + this.props.workOrder.qrCode}/>
                        </div>
                        <div className="woCell qrCodeValue">{this.props.workOrder.workOrderNo}</div>
                    </div>
                    <div className="woContainerCardNo">
                        <div className="woCell woCellTop woCellCardNo">
                        <b>{work_order_work_card_no}</b>
                        </div>
                        <div className="woCell woCellMiddle woCellCardNo">
                        <b style={{color:'red'}}>{this.props.workOrder.workCardId}</b>
                        </div>                        
                    </div>
                    <div className="woContainerDate">
                        <div className="woCell woCellTop woCellDate"><b>{work_order_order_date_s}</b></div>
                        <div className="woCell woCellTop woCellDate">{WorkOrderUtil.formatShortDisplayDateMMddyyyy(this.props.workOrder.orderDate)}</div>
                        <div className="woCell woCellMiddle woCellDate"><b>{work_order_start_date}</b></div>
                        <div className="woCell woCellMiddle woCellDate">{WorkOrderUtil.formatShortDisplayDateMMddyyyy(this.props.workOrder.startDate)}</div>
                        <div className="woCell woCellMiddle woCellDate"><b>{work_order_end_date}</b></div>
                        <div className="woCell woCellMiddle woCellDate">{WorkOrderUtil.formatShortDisplayDateMMddyyyy(this.props.workOrder.endDate)}</div>
                    </div>
                    <div className="woContainerOptions">
                        <div className="woCell woCellMiddleLeft"><b>{work_order_code}</b></div>
                        <div className="woCell woCellMiddle">{this.props.workOrder.sku}</div>
                        <div className="woCell woCellMiddle"><b>{work_order_code_p}</b></div>
                        <div className="woCell woCellMiddle">{this.props.workOrder.fullPCode}</div>
                        <div className="woCell woCellMiddle"><b>{work_order_color}</b></div>
                        <div className="woCell woCellMiddle">{this.props.workOrder.colorMaterial}</div>
                        <div className="woCell woCellMiddleLeft"><b>{work_order_type}</b></div>
                        <div className="woCell woCellMiddle">{this.props.workOrder.shapeDesign}</div>
                        <div className="woCell woCellMiddle"><b>{work_order_quantity_s}</b></div>
                        <div className="woCell woCellMiddle">{this.props.workOrder.qty}</div>
                        <div className="woCell woCellMiddle"><b>{work_order_size}</b></div>
                        <div className="woCell woCellMiddle">{this.props.workOrder.lengthSize}</div>
                    </div>
                    <div className="woContainerCustomer">
                        <div className="woCell woCellMiddleLeft"><b>{work_order_customer_s}</b></div>
                        <div className="woCell woCellMiddle">{this.props.workOrder.customer}</div>
                        <div className="woCell woCellMiddle"><b>{work_order_urgent}</b></div>
                        <div className="woCell woCellMiddle">{this.props.workOrder.carrierServiceRequested}</div>
                    </div>
                    <div className="woContainerImages">
                        <div className="woCell woCellMiddleLeft"><WorkOrderImagesPrint workOrderId={this.props.workOrderId}/></div>
                    </div>
                    <div className="woContainerCustomerNote">
                        <div className="woCell woCellMiddleLeft"><b>{work_order_customer_note}</b></div>
                        <div className="woCell woCellMiddle">{this.props.workOrder.notesFromBuyer}</div>
                        <div className="woCell woCellMiddle"><b>{work_order_special_note}</b></div>
                        <div className="woCell woCellMiddle">{this.props.workOrder.notesInternal}</div>
                    </div>                    
                </div>
            );
        }else{
            return (<div>&nbsp;</div>)
        }
    }
}

export default WorkOrderPrint;